/*
**************************** 
홈페이지 아이디 찾기 시작화면
*****************************
*/

import axios from "axios";
import { useEffect, useState } from "react";
import FindResult from "./FindResult";

export default function FindUser() {
    const [findUserData, setFindUserData] = useState({ withData: { name: "", email: "" } });

    useEffect(() => {

        return () => {
            resetFunc();
        }
    }, []);

    const resetFunc = function () {
        let copyfindUserData = { ...findUserData };
        copyfindUserData.withData = { name: "", email: "" };
        setFindUserData(copyfindUserData);

    };

    const setFuncName = (e) => {
        let copyfindUserData = { ...findUserData };
        copyfindUserData.withData.name = e.target.value;
        setFindUserData(copyfindUserData);

    };

    const setFunc = (e) => {
        let copyfindUserData = { ...findUserData };
        copyfindUserData.withData.email = e.target.value;
        setFindUserData(copyfindUserData);

    };

    const requestOtp = async function () {
        const otp_to = findUserData.withData;
        const otp_to_name = otp_to.name;
        const otp_to_email = otp_to.email;
        const otp_to_type = '0';

        if (otp_to.name === "" || otp_to.name === undefined || otp_to.email === "" || otp_to === undefined) {
            alert("가입한 이름 또는 이메일을 확인 하세요")
            return;
        }

        resetFunc();

        const reqSql = "/api/users/otp";
        const params = { otp_to_name, otp_to_email, otp_to_type };
        await axios.post(reqSql, params, { 'Content-Type': 'application/json', withCredentials: true }).then(function (res) {
            if (res.status === 200) {
                window.findR();
            } else {
                if (res.status === 204) {
                    alert("인증번호 실패");
                } else {
                    alert("데이터 가져오는 도중 오류가 발생하였습니다.");
                }
            }
        }).catch(function (err) {
            console.log(err);
            alert("데이터 가져오는 도중 오류가 발생하였습니다.");
        });
    }

    return (
        <div>
            <div className="modal fade" id="findUser" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">아이디 찾기</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => {
                                resetFunc();
                            }}></button>
                        </div>
                        <div className="modal-body">
                            <ul className="nav nav-tabs " role="tablist">
                            </ul>
                            <div id="myTabContent" className="tab-content">
                                <div className="tab-pane  active show" id="finId" role="tabpanel">
                                    <div className="sign-in">
                                        <div className="accordion" id="accordionExample" >
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="headingOne">
                                                    <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne" onClick={(e) => {
                                                        resetFunc();
                                                    }}  >
                                                        가입한 이메일로 찾기
                                                    </button>
                                                </h2>
                                                <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                                    <div className="accordion-body">
                                                        <form >
                                                            <div className="form-group text-start">
                                                                <input type="text" className="form-control" placeholder="가입한 이름" name="userName" value={findUserData.withData.name || ''} onChange={(e) => {
                                                                    setFuncName(e);
                                                                }} required></input>
                                                            </div>
                                                            <div className="form-group text-start mt-1">
                                                                <input type="text" className="form-control" placeholder="이메일을 입력해 주세요" name="userName" value={findUserData.withData.email || ''} onChange={(e) => {
                                                                    setFunc(e);
                                                                }} required></input>
                                                            </div>
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group mt-4 row p-2">
                                                <button type="button" className="btn btn-lg btn-primary" data-bs-dismiss="modal" onClick={() => {
                                                    requestOtp();
                                                }}>인증하기</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <FindResult></FindResult>
        </div>
    )
}